import { render } from "./InputSimple.vue?vue&type=template&id=62795943&scoped=true"
import script from "./InputSimple.vue?vue&type=script&lang=js"
export * from "./InputSimple.vue?vue&type=script&lang=js"

import "./InputSimple.vue?vue&type=style&index=0&id=62795943&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62795943"]])

export default __exports__